import 'immer'; // this is needed for immer type bug, try removing it later
import {z} from 'zod';
import {create} from 'zustand';
import {createJSONStorage, persist} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

import {LOCAL_STORAGE_PREFIX} from './constants';

// store
export const useSettingsStore = create<SettingsStore>()(
  persist(
    immer((set) => ({
      theme: 'system',

      actions: {
        setValue: (key, value) => {
          set((state) => {
            // @ts-expect-error not sure how to type this properly
            state[key] = value;
          });
        },
      },
    })),
    {
      name: LOCAL_STORAGE_PREFIX + 'settings',
      version: 1,
      storage: createJSONStorage(() => localStorage),

      partialize: ({actions, ...rest}) => rest,

      migrate: (cached) => {
        return settingsSchema.parse(cached);
      },
    }
  )
);

// hooks
export const useSetting = <T extends keyof Omit<SettingsStore, 'actions'>>(
  key: T
): SettingsStore[T] => useSettingsStore((state) => state[key]);
export const useSettingActions = () =>
  useSettingsStore((state) => state.actions);

export const settingsSchema = z.object({
  // UI theme
  theme: z.enum(['system', 'light', 'dark']),
});
type SettingsStore = z.infer<typeof settingsSchema> & {
  actions: {
    setValue: (key: string, value: unknown) => void;
  };
};
